// extracted by mini-css-extract-plugin
module.exports = {"btn":"JoinButton_btn__p17Re","hidden":"JoinButton_hidden__1yW2t"};